<template>
  <div class="calico-ai-reply-page">
    <CalicoAIReply
      message="Nunc auctor amet sit egestas purus eu bibendum urna.
    Nunc auctor amet sit egestas purus eu bibendum urna.
    Nunc auctor amet sit egestas purus eu bibendum urna.
    Nunc auctor amet sit egestas purus eu bibendum urna.
    Nunc auctor amet sit egestas purus eu bibendum urna."
    />
  </div>
</template>

<script>
import CalicoAIReply from '@/components/calico/aiReply/index.vue';

export default {
  name: 'CalicoAIReplyPage',
  components: {
    CalicoAIReply,
  },

};
</script>

<style lang="scss">
.calico-ai-reply-page {
  @include stack-space($space-large);
  justify-content: center;
  align-items: center;
  padding: $space-large;
  width: 50%;
}
</style>